var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-list',_vm._l((_vm.workLeaveApprovals),function(item){return _c('ListItemApproval',{key:item.id,attrs:{"workLeaveApproval":item,"department":item.approvalStep === 1
        ? 'Department Manager / Giám đốc - Trưởng bộ phận'
        : 'Phòng NS-PL',"step":item.approvalStep,"status":item.status}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }